import SwisscomFooter from '@/components/Footer/Footer.vue'
import Notification from '@/components/Notification/Notification.vue'

export default {
   name: 'Login',
   components: {
      SwisscomFooter,
      Notification
   }
}
